/*
 * fn: encodeArchidektDeck
 *
 * Encodes a list of recs into the archidekt deck format
 *
 */
import { type CardMapType } from '@/defs/card'
import { type RecType } from '@/defs/rec'

type Props = {
  cardMap: CardMapType
  recs: RecType[]
}

export const encodeArchidektDeck = ({ cardMap, recs }: Props) =>
  recs.flatMap(({ cardId, count, partnerRef, role }) => [
    {
      c: role === 'commander' ? 'c' : 'm',
      f: 0,
      q: count || 1,
      u: cardMap[cardId]?.scryfallId,
    },
    ...(partnerRef
      ? [
          {
            c: role === 'commander' ? 'c' : 'm',
            f: 0,
            q: count || 1,
            u: cardMap[partnerRef.cardId]?.scryfallId,
          },
        ]
      : []),
  ])
